import React, {useEffect, useState} from 'react';
import {Alert, Button, message, Select, Space} from "antd";

import {HabitsService} from "services";
import {PavlokDeviceModel} from "../../../../types";

interface EditHabitDeviceModelsProps {
    habitId?: string
}

const DEVICE_MODEL_OPTIONS = Object.values(PavlokDeviceModel).map((value) => ({
    label: value,
    value,
}));

const EditHabitDeviceModels: React.FC<EditHabitDeviceModelsProps> = ({habitId}) => {
    const [loading, setLoading] = useState<boolean>(false);
    const [saving, setSaving] = useState<boolean>(false);
    const [selected, setSelected] = useState<string[]>([]);

    useEffect(() => {
        fetchDeviceModels();
    }, [habitId]);

    const fetchDeviceModels = () => {
        if (!habitId) return;
        setLoading(true);
        HabitsService.getHabitDeviceModels(habitId)
            .then((res) => {
                setSelected(res?.data?.deviceModels || []);
            })
            .catch((err) => {
                console.error(err);
                message.error('Error loading device models! Check logs.');
            })
            .finally(() => {
                setLoading(false);
            });
    };

    const handleSave = () => {
        if (!habitId) return;
        setSaving(true);
        HabitsService.setHabitDeviceModels(habitId, selected)
            .then((res) => {
                setSelected(res?.data?.deviceModels || []);
                message.success('Device models updated');
            })
            .catch((err) => {
                console.error(err);
                message.error('Error updating device models! Check logs.');
            })
            .finally(() => {
                setSaving(false);
            });
    };

    return (
        <Space direction="vertical" style={{width: '100%'}} size="middle">
            <Alert
                type="info"
                message="During onboarding, this habit will be suggested to users who own the selected devices."
            />
            <Select
                mode="multiple"
                allowClear
                style={{width: '100%'}}
                placeholder="Select the device models this habit should appear for"
                loading={loading}
                value={selected}
                onChange={setSelected}
                options={DEVICE_MODEL_OPTIONS}
            />
            <Button type="primary" htmlType="button" loading={saving} onClick={handleSave}>
                Save device models
            </Button>
        </Space>
    );
};

export default EditHabitDeviceModels;
